import User from 'auth/User';
import { login } from 'auth/store/actions';
import { getIsLoggedIn, getIsLogging } from 'auth/store/selectors';
import { Layouts, PageLayoutParams } from 'layouts/LayoutProvider';
import { Box, Column, Container, Grid } from 'lmc-ui-library';
import React, { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import Banner from 'screens/BrokerPortal/screens/Registration/components/UI/Banner/Banner';
import { PageComponentProps } from 'shared/interface/globalInterface';
import homePage, { navigateExternal } from 'utils/navigation/navigation';
import SignInForm from '../../components/Form/SignInForm/SignInForm';
import { Form } from '../../components/Form/SignInForm/types';
import styles from './SignIn.module.scss';

const SignIn: React.FC<PageComponentProps> & PageLayoutParams = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoggedIn = useSelector((state: any) => getIsLoggedIn(state));
  const user: User = useSelector((state: any) => state.auth.user);
  const isLogging: boolean = useSelector(getIsLogging);
  const { loginError } = useSelector((state: any) => state.auth, shallowEqual);
  const location = useLocation<{
    error?: string;
    from?: string;
  }>();
  const error = location.state !== undefined && location.state.hasOwnProperty('error') ? location.state.error : false;
  const from = location.state !== undefined && location.state.hasOwnProperty('from') ? location.state.from : false;

  const handleLogin = (values: Form) => {
    if (values.username && values.password) {
      dispatch(login(values.username, values.password));
    }
  };

  const navigate = useCallback(
    (path: string) => {
      history.push(from ? from : path);
    },
    [history, from],
  );

  useEffect(() => {
    if (isLoggedIn) {
      const homePageRoute = homePage(user);
      homePageRoute.isExternal ? navigateExternal(homePageRoute.route) : navigate(homePageRoute.route);
    }
  }, [isLoggedIn, navigate, user]);

  return (
    <Container style={{ width: '438px' }}>
      <Grid cols={10} mb={0} p={0}>
        <Column md={10} sm={12} xs={12}>
          {error && <Banner mode="error" heading="Sorry, it appears something went wrong." message={error} />}
          <Box borderRadius={2} pt={10} pb={10}>
            <Box.Content>
              <Grid cols={12}>
                <Column lg={12} md={12} sm={12} xs={12}>
                  <SignInForm
                    onLogin={handleLogin}
                    error={loginError}
                    isLogging={isLogging}
                    className={styles.signInForm}
                  />
                </Column>
              </Grid>
            </Box.Content>
          </Box>
        </Column>
      </Grid>
    </Container>
  );
};

SignIn.layout = Layouts.SIGN_IN;

export default SignIn;
